import { render } from "./PopinHelp.vue?vue&type=template&id=3eca6e58&scoped=true"
import script from "./PopinHelp.vue?vue&type=script&lang=js"
export * from "./PopinHelp.vue?vue&type=script&lang=js"

import "./PopinHelp.vue?vue&type=style&index=0&id=3eca6e58&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eca6e58"]])

export default __exports__